'use strict';

angular.module('app').directive('mobileMenu', function ($rootScope, $timeout) {
    return {
        link: function (scope, element) {
            var _elem, menu, menuHeaderMobile, activeTab,
                mobileLogo, backIcon, homepageHeader,searchPageItems

            scope.$on('$destroy', function () {
                _elem.off('click touchstart');
                $(window).off('resize');
                backIcon.off('click touchend');
                searchPageItems.off('click touchend');
            });

            $rootScope.$on("$viewContentLoaded", init);

            if (window.isHomePage || $rootScope.code404) {
                init();
            }

            function hideMenu() {
                activeTab = null;
                _elem.removeClass('active');
                menu.hide();
                menuHeaderMobile.nextAll().show();
                homepageHeader.removeClass('opened');
                backIcon.hide();

                $timeout(function () {
                    mobileLogo.show();
                }, 50);
            }

            function clickingCallback(el) {
                var _this = $(this);

                el.preventDefault();
                _elem.removeClass('active');


                $('.js-header-mobile > div').hide();



                if (activeTab === _this.data('item').toString()) {
                    hideMenu();

                    return true;
                } else {
                    if (menu.css('display') === 'none' && !activeTab) {
                        _this.addClass('active');
                        menu.show();
                        homepageHeader.addClass('opened');
                        menuHeaderMobile.nextAll().hide();
                        mobileLogo.hide();
                        backIcon.show();
                    } else if (menu.css('display') && activeTab) {
                        _this.addClass('active');
                        homepageHeader.addClass('opened');
                        menu.show();
                        mobileLogo.hide();
                        backIcon.show();
                    }
                }

                activeTab = _this.data('item').toString();

                $('.js-header-mobile .' + activeTab).show();

                return false;
            }

            function init() {
                _elem = $(element).find('li:not(.do-not-trigger)');
                menu = $('.toggle-menu');
                menuHeaderMobile = $('.js-header-mobile');
                backIcon = $('.mobile-back-icon'),
                mobileLogo = $('.mobile-header .logo');
                homepageHeader = $('.mobile-header.homepage-header');

                searchPageItems = $('.do-not-trigger');

                _elem.on('touchstart click', clickingCallback);

                backIcon.on('touchend click',hideMenu);
                searchPageItems.on('touchend click', function(){
                    if (activeTab) {
                        hideMenu();
                    }
                });

                $(window).on('resize',function () {
                    if (activeTab && this.innerWidth > 1023) {
                        hideMenu();
                    }
                });
            }
        },
        restrict: 'A'
    };
});